import React, { Component } from 'react';
import { Card, Avatar, message, Icon, Input, List, Tag, Breadcrumb } from 'antd';
import { Redirect } from 'react-router-dom';
import PublicMenu from '../../components/TopMenu';
import FavButton from '../../components/FavButton';
import TicketMessageModal from '../../components/modals/public/TicketMessageModal';
import axios from 'axios';
import Configuration from '../../Configuration';
const { Meta } = Card;
const Search = Input.Search;

class Ticket extends Component {
  constructor() {
    super();
    this.schema = {body: '', ticket_id: 1};
    this.headers = {Authorization: localStorage.getItem('visitapp:token')};
    this.state = {redirect: false, ticket: {name: '', status: true, messages: []}, filteredMessages: [], ticketModal: false};
    this.validateToken = this.validateToken.bind(this);
    this.handleStatus = this.handleStatus.bind(this);
    this.getTicket = this.getTicket.bind(this);
    this.handleCreate = this.handleCreate.bind(this);
    this.handleOpenModal = this.handleOpenModal.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
  }

  componentDidMount() {
    this.validateToken();
    this.getTicket();
  }

  validateToken() {
    if(!localStorage.getItem('visitapp:token'))
      this.setState({redirect: true});
    
    if(!Configuration.isInRol(localStorage.getItem('visitapp:rol'), "admin or gerente or empleado or guardia"))
      this.setState({redirect: true});
  }

  getTicket() {
    const id = this.props.match.params.id;

    axios.get(`${Configuration.apiServer}/api/v1/tickets/${id}`, {headers: this.headers}).then(resp => {
      if(resp.status !== 200)
        return message.warning('Hubo un error al procesar los datos')
      
      if(resp.data.status === 'error')
        return message.warning('Petición inválida')

      console.log(resp.data);
      this.setState({ticket: resp.data, messages: resp.data.ticket_messages, filteredMessages: resp.data.ticket_messages});
    });
  }

  handleStatus(id) {
    axios.put(`${Configuration.apiServer}/api/v1/tickets/${id}/status`, {}, {headers: this.headers}).then(resp => {
      if(resp.status !== 200)
        return message.warning('Hubo un error al procesar los datos')
      
      if(resp.data.status === 'error')
        return message.warning('Petición inválida')

      message.success('Registro actualizado')
      this.getTicket();
    });
  }

  handleCreate(record) {
    const id = this.props.match.params.id;
    record['ticket_id'] = id;

    axios.post(`${Configuration.apiServer}/api/v1/ticket_messages`, {ticket_message: record}, {headers: this.headers}).then(resp => {
      if(resp.status !== 200)
        return message.warning('Hubo un error al procesar los datos');

      if(resp.data.status === 'error')
        return message.warning('Petición inválida');

      message.success('Registro creado');
      this.handleCloseModal();
      this.getTicket();
    });
  }

  handleOpenModal() {
    this.setState({ticketModal: true});
  }

  handleCloseModal() {
    this.setState({ticketModal: false});
  }

  handleSearch(event) {
    const messages = this.state.messages.filter(message => {
      return message.body.toLowerCase().indexOf(event.target.value.toLowerCase()) > -1
    });

    this.setState({filteredMessages: messages});
  }
  
  render() {
    // Verify authentication
    if(this.state.redirect) {
      return (
        <Redirect to="/" />
      );
    }

    // Render component
    return (
      <div>
        <PublicMenu />
        
        <div className="container" style={{ marginTop: '30px' }}>
          <div className="d-flex flex-row flex-start">
            <Breadcrumb>
              <Breadcrumb.Item> <a href="/support/tickets">Tickets</a> </Breadcrumb.Item>
              <Breadcrumb.Item>{this.state.ticket.titile}</Breadcrumb.Item>
            </Breadcrumb>
          </div>

          <br/>

          <div className="d-flex flex-row flex-wrap justify-content-between">
            <div style={{ width: '30%', padding: '0px 10px' }}>
              <Search placeholder="Buscar..." onChange={this.handleSearch} style={{ width: '100%' }} />

              <br/><br/>

              <Card
                style={{ width: '100%', margin: '0px' }}
              >
                <Meta
                  avatar={<Avatar icon="solution" />}
                  title={this.state.ticket.titile}
                  description={<span className={`cursor text-${Configuration.getStatus(this.state.ticket.status).color}`} onClick={() => { this.handleStatus(this.state.ticket.id) }}>{(this.state.ticket.status) ? 'Concluido' : 'Pendiente'}</span>}
                />
                <p className="text-muted" style={{ marginTop: '15px', marginLeft: '45px' }}>
                  <Icon type="user" /> { ('profile' in this.state.ticket) ? this.state.ticket.profile.names : 'Sin usuario' }
                </p>
                <p className="text-muted" style={{ marginTop: '15px', marginLeft: '45px' }}>
                  <Icon type="file" /> {this.state.ticket.body}
                </p>
              </Card>
            </div>

            <div style={{ width: '70%', padding: '0px 10px' }}>
              <List
                itemLayout="horizontal"
                dataSource={this.state.filteredMessages}
                renderItem={message => (
                  <List.Item>
                    <List.Item.Meta
                      avatar={<Avatar src="https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png" />}
                      title={<a href="https://ant.design">{message.body}</a>}
                      description={
                        <div className="d-flex justify-content-between align-items-center">
                          <span><Icon type="user" /> {message.profile.names}</span>
                          <Tag color="cyan">{Configuration.formatDatetime(message.created_at)}</Tag>
                        </div>
                      }
                    />
                  </List.Item>
                )}
              />
            </div>
          </div>
        </div>

        <FavButton handleClick={this.handleOpenModal} schema={this.state.current} />
        <TicketMessageModal visible={this.state.ticketModal} current={this.schema} title="Nuevo mensaje" handleClose={this.handleCloseModal} handleSave={this.handleCreate}  />

      </div>
    );
  }
}

export default Ticket;



// WEBPACK FOOTER //
// ./src/pages/public/Ticket.js